<template>
  <section
    :style="{ 'background-color': $theme.grey }"
    style="margin-bottom: 6rem;"
  >
    <div class="row LP-header">
      <div class="col">
        <div class="container">
          <router-link
            :to="{ name: 'main-application', params: $route.params.id }"
            aria-label="Back to loan overview"
            tabindex="4"
            v-b-popover.hover.top="'Go To Overview'"
          >
            <h1
              style="font-weight: normal;cursor: pointer"
              class="display-4"
              tabindex="4"
            >
              <round-icon
                name="ni ni-single-copy-04"
                type="success"
              ></round-icon>

              <!-- TODO: Tie to Loan TypeID -->
              Mortgage Loan
              <small class="text-muted" v-if="subTitle"
                >/ Application
                <i
                  class="fa fa-lock text-success success"
                  aria-hidden="true"
                ></i>
              </small>
            </h1>
          </router-link>

          <div
            class="col"
            style="margin-top: -2rem;margin-left: 2.5rem;padding-right: 2.5rem;"
          >
            <base-progress
              v-if="progress != 0"
              style="padding: 0; margin-top: 20px;margin-bottom: -30px;"
              type="success"
              :value="progress"
              :showPercent="false"
            ></base-progress>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" style="margin-top: 40px;min-height: 100px;">
        <div class="col">
          <div class="loader" v-if="loading" style="margin-top: -3rem;">
            <div class="loader-box">
              <i
                class="fa fa-spinner success"
                :style="{ color: $theme.success }"
                aria-hidden="true"
              ></i>
            </div>
          </div>
          <template v-if="page.PageID">
            <div class="templ" :class="{ in: ready }">
              <div
                style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
                <h5>{{ page.Title }}</h5>
                <div>
                  <base-button
                  v-if="
                    this.app.progress.sections.fields.pages.length &&
                      page.PageID !=
                        this.app.progress.sections.fields.pages[0].id
                  "
                  type="secondary"
                  style="margin-top: 20px;"
                  @click="BackPage"
                  >Back</base-button
                >
                <base-button
                  type="primary"
                  style="margin-top: 20px;"
                  @click="NextPage"
                  >Next</base-button
                >
                </div>
               
              </div>

              <p
                class="lead"
                style="margin: 0 0 2rem;"
                v-html="page.Description"
              ></p>
              <div v-for="field of appFields" :key="field.NameID">
                <div v-if="field.length">
                  <div class="row" style="margin-bottom: .5rem;">
                    <div
                      class="col-sm"
                      v-for="subField of field"
                      :key="subField.NameID"
                    >
                      <label
                        :for="subField.Name"
                        v-if="subField.Type != 7 && subField.Type != 8"
                      >
                        <i
                          v-if="subField.HelpText"
                          class="fa fa-info-circle"
                          aria-hidden="true"
                          v-b-popover.hover.top="subField.HelpText"
                        ></i>
                        {{ subField.Name }}
                        <span v-if="subField.Required" style="color:#fb6340"
                          >*</span
                        >
                      </label>
                      <div
                        style="font-size: 14px;color: #525f7f;padding-bottom: 6px;"
                        v-if="subField.Description"
                        v-html="subField.Description"
                      ></div>
                      <base-input
                        v-if="
                          (subField.Type == 1 || subField.Type == 2) &&
                            !subField.FieldJSON.mask
                        "
                        :addon-left-icon="subField.FieldJSON.icon"
                        :placeholder="subField.Placeholder"
                        :id="subField.Name"
                        v-model="subField.Value"
                        :type="subField.Type == 1 ? 'text' : 'number'"
                        :required="subField.Required"
                        :valid="subField.Valid"
                        @change="subField.Valid = null"
                        :disabled="field.Disable"
                      ></base-input>
                      <base-input
                        v-if="
                          (subField.Type == 1 || subField.Type == 2) &&
                            subField.FieldJSON.mask
                        "
                        :addon-left-icon="subField.FieldJSON.icon"
                        :placeholder="subField.Placeholder"
                        :id="subField.Name"
                        v-model="subField.Value"
                        :type="subField.Type == 1 ? 'text' : 'number'"
                        :required="subField.Required"
                        :valid="subField.Valid"
                        @change="subField.Valid = null"
                        v-mask="subField.FieldJSON.mask"
                        :disabled="field.Disable"
                      ></base-input>
                      <!-- Currency -->
                      <money
                        v-model="subField.Value"
                        v-bind="{
                          decimal: '.',
                          thousands: ',',
                          prefix: '$ ',
                          suffix: '',
                          precision: 2,
                        }"
                        v-if="subField.Type == 6"
                        :id="subField.Name"
                        @blur="setNull(subField)"
                        :disabled="subField.Disable"
                        :placeholder="subField.Placeholder"
                        class="lp-select"
                        :class="[
                          { 'has-success': subField.Valid === true },
                          { 'has-danger': subField.Valid === false },
                        ]"
                        style="border: none;width: 100%;"
                      ></money>
                      <!-- Text-Area -->
                      <textarea
                        v-if="subField.Type == 9"
                        class="form-control form-control-alternative"
                        :id="subField.Name"
                        rows="3"
                        :placeholder="subField.Placeholder"
                        :valid="subField.Valid"
                        :required="subField.Required"
                        :disabled="subField.Disable"
                        v-model="subField.Value"
                        @change="subField.Valid = null"
                      ></textarea>
                      <!-- Checkbox -->
                      <base-checkbox
                        class="mb-3"
                        v-model="subField.Value"
                        v-if="subField.Type == 8"
                        :valid="subField.Valid"
                        :disabled="field.Disable"
                      >
                        <i
                          :class="subField.FieldJSON.icon"
                          aria-hidden="true"
                          v-if="subField.FieldJSON.icon"
                        ></i>
                        {{ subField.Name }}
                        <span v-if="subField.Required" style="color:#fb6340"
                          >*</span
                        >
                      </base-checkbox>
                      <!-- Select -->
                      <select
                        v-if="subField.Type == 5"
                        class="form-select lp-select"
                        aria-label="Default select example"
                        :valid="subField.Valid"
                        :required="subField.Required"
                        :disabled="subField.Disable"
                        v-model="subField.Value"
                        @change="subField.Valid = null"
                      >
                        <option selected>{{ subField.Placeholder }}</option>
                        <option
                          v-for="opt of subField.Options"
                          :key="opt.Key"
                          :value="opt.Value"
                          >{{ opt.Value }}</option
                        >
                      </select>
                      <!-- Date Picker -->
                      <base-input
                        addon-left-icon="ni ni-calendar-grid-58"
                        v-if="subField.Type == 4"
                        @change="subField.Valid = null"
                        :valid="subField.Valid"
                        :required="subField.Required"
                        :id="subField.Name"
                        :disabled="field.Disable"
                      >
                        <flat-picker
                          :id="subField.Name"
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="{ allowInput: true, dateFormat: 'm/d/Y' }"
                          class="form-control datepicker"
                          v-model="subField.Value"
                          @change="subField.Valid = null"
                        >
                        </flat-picker>
                      </base-input>
                      <div
                        v-if="subField.Type == 3"
                        style="display: flex;flex-wrap: wrap;"
                      >
                        <div
                          v-for="opt of subField.Options"
                          :key="opt.Key"
                          style="margin-right: 20px;"
                        >
                          <base-radio
                            :name="opt.Value"
                            class="mb-3"
                            v-model="subField.Value"
                            :valid="subField.Valid"
                            :required="subField.Required"
                            @change="subField.Valid = null"
                            :disabled="field.Disable"
                          >
                            {{ opt.Key }}
                          </base-radio>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!field.length">
                  <div class="row" style="margin-bottom: .5rem;">
                    <div class="col-sm">
                      <label
                        :for="field.Name"
                        v-if="field.Type != 7 && field.Type != 8"
                      >
                        <i
                          v-if="field.HelpText"
                          class="fa fa-info-circle"
                          aria-hidden="true"
                          v-b-popover.hover.top="field.HelpText"
                        ></i>
                        {{ field.Name }}
                        <span v-if="field.Required" style="color:#fb6340"
                          >*</span
                        >
                      </label>
                      <div
                        style="font-size: 14px;color: #525f7f;padding-bottom: 6px;"
                        v-if="field.Description"
                        v-html="field.Description"
                      ></div>
                      <!-- Text Input -->
                      <base-input
                        v-if="
                          (field.Type == 1 || field.Type == 2) &&
                            !field.FieldJSON.mask
                        "
                        :addon-left-icon="field.FieldJSON.icon"
                        :placeholder="field.Placeholder"
                        :id="field.Name"
                        v-model="field.Value"
                        :type="field.Type == 1 ? 'text' : 'number'"
                        :required="field.Required"
                        :valid="field.Valid"
                        :disabled="field.Disable"
                        @change="field.Valid = null"
                      ></base-input>
                      <base-input
                        v-if="
                          (field.Type == 1 || field.Type == 2) &&
                            field.FieldJSON.mask
                        "
                        :addon-left-icon="field.FieldJSON.icon"
                        :placeholder="field.Placeholder"
                        :id="field.Name"
                        v-model="field.Value"
                        :type="field.Type == 1 ? 'text' : 'number'"
                        :required="field.Required"
                        :valid="field.Valid"
                        @change="field.Valid = null"
                        :disabled="field.Disable"
                        v-mask="field.FieldJSON.mask"
                      ></base-input>
                      <!-- Currency -->
                      <money
                        v-model="field.Value"
                        v-bind="{
                          decimal: '.',
                          thousands: ',',
                          prefix: '$ ',
                          suffix: '',
                          precision: 2,
                        }"
                        v-if="field.Type == 6"
                        :id="field.Name"
                        @blur="setNull(field)"
                        :disabled="field.Disable"
                        :placeholder="field.Placeholder"
                        class="lp-select"
                        :class="[
                          { 'has-success': field.Valid === true },
                          { 'has-danger': field.Valid === false },
                        ]"
                        style="border: none;width: 100%;"
                      ></money>

                      <!-- Checkbox -->
                      <base-checkbox
                        class="mb-3"
                        v-model="field.Value"
                        :valid="field.Valid"
                        v-if="field.Type == 8"
                        :disabled="field.Disable"
                      >
                        <i
                          :class="field.FieldJSON.icon"
                          aria-hidden="true"
                          v-if="field.FieldJSON.icon"
                        ></i>
                        {{ field.Name }}
                        <span v-if="field.Required" style="color:#fb6340"
                          >*</span
                        >
                      </base-checkbox>
                      <!-- Select -->
                      <select
                        v-if="field.Type == 5"
                        class="form-select lp-select"
                        aria-label="Default select example"
                        :valid="field.Valid"
                        :required="field.Required"
                        :disabled="field.Disable"
                        v-model="field.Value"
                        @change="field.Valid = null"
                      >
                        <option selected>{{ field.Placeholder }}</option>
                        <option
                          v-for="opt of field.Options"
                          :key="opt.Key"
                          :value="opt.Value"
                          >{{ opt.Value }}</option
                        >
                      </select>

                      <!-- Date Picker -->
                      <base-input
                        addon-left-icon="ni ni-calendar-grid-58"
                        v-if="field.Type == 4"
                        alternative
                        @change="field.Valid = null"
                        :valid="field.Valid"
                        :required="field.Required"
                        :disabled="field.Disable"
                      >
                        <flat-picker
                          :id="field.Name"
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="{ allowInput: true, dateFormat: 'm/d/Y' }"
                          class="form-control datepicker"
                          v-model="field.Value"
                          @change="field.Valid = null"
                          style="color: #172b4d;"
                        >
                        </flat-picker>
                      </base-input>
                      <!-- Text-Area -->
                      <textarea
                        v-if="field.Type == 9"
                        class="form-control form-control-alternative"
                        :id="field.Name"
                        rows="3"
                        :placeholder="field.Placeholder"
                        :valid="field.Valid"
                        :required="field.Required"
                        :disabled="field.Disable"
                        v-model="field.Value"
                        @change="field.Valid = null"
                      ></textarea>
                      <!-- Multi-Choice -->
                      <div
                        v-if="field.Type == 3"
                        style="display: flex;flex-wrap: wrap;"
                      >
                        <div
                          v-for="opt of field.Options"
                          :key="opt.Key"
                          style="margin-right: 20px;"
                          @click="field.Valid = null"
                        >
                          <base-radio
                            :name="opt.Value"
                            class="mb-3"
                            v-model="field.Value"
                            :valid="field.Valid"
                            :required="field.Required"
                            :disabled="field.Disable"
                          >
                            {{ opt.Key }}
                          </base-radio>
                        </div>
                      </div>
                      <!-- Table -->
                      <h6 v-if="field.Type == 7">{{ field.Name }}</h6>
                      <div
                        v-if="field.Type == 7"
                        class="col-sm"
                        style="padding: 0;"
                      >
                        <div
                          class="row"
                          v-for="(tableRow, i) of field.Table"
                          :key="i"
                          style="position: relative; border-radius: 4px;margin-right: 0; margin-left: 0;margin-bottom: 2rem;"
                        >
                          <i
                            v-if="i !== 0 && field.FieldJSON.table.rowRemoval"
                            @click="field.Table.splice(i, 1)"
                            style="position: absolute;top: 8px;right: 0;cursor: pointer;z-index:10;"
                            class="fa fa-times"
                            aria-hidden="true"
                          ></i>
                          <div
                            class="col-sm tableColumn"
                            style="display: flex;flex-direction: column;justify-content: space-between;"
                            v-for="(tableD, l) of tableRow"
                            :key="l"
                          >
                            <div>
                              <label :for="tableD.Name">{{
                                tableD.Name
                              }}</label>
                            </div>
                            <!-- Text and Number -->
                            <base-input
                              style="box-shadow: none !important; margin: 0;"
                              v-if="
                                tableD.FieldTypeID === 1 ||
                                  tableD.FieldTypeID === 2
                              "
                              :addon-left-icon="tableD.Icon"
                              alternative
                              :placeholder="tableD.Placeholder"
                              :id="tableD.Name"
                              v-model="tableD.Value"
                              :type="
                                tableD.FieldTypeID === 1 ? 'text' : 'number'
                              "
                              :required="tableD.Required"
                              :valid="tableD.Valid"
                              @change="tableD.Valid = null"
                              :table="true"
                            ></base-input>
                            <!-- Currency -->
                            <money
                              v-model="tableD.Value"
                              v-bind="{
                                decimal: '.',
                                thousands: ',',
                                prefix: '$ ',
                                suffix: '',
                                precision: 2,
                              }"
                              v-if="tableD.FieldTypeID == 6"
                              :id="tableD.Name"
                              :required="tableD.Required"
                              :valid="tableD.Valid"
                              @change="tableD.Valid = null"
                              :disabled="tableD.Disable"
                              :placeholder="tableD.Placeholder"
                              class="lp-select"
                              style="border: none;width: 100%;"
                            ></money>
                            <!-- Multi-Choice -->
                            <div
                              v-if="tableD.FieldTypeID === 3"
                              style="display: flex;flex-wrap: wrap;"
                            >
                              <div
                                v-for="(opt, p) of tableD.Options"
                                :key="opt.Key"
                                style="margin-right: 20px;"
                                @click="tableD.Valid = null"
                              >
                                <div class="radio-LP">
                                  <input
                                    :id="i + tableD.Name + p"
                                    :class="[
                                      { 'is-valid': tableD.Valid === true },
                                      { 'is-invalid': tableD.Valid === false },
                                    ]"
                                    :name="tableD.Name + i"
                                    type="radio"
                                    :required="tableD.Required"
                                    :disabled="tableD.Disable"
                                    :value="opt.Value"
                                    @change="
                                      field.Table[i][l].Value =
                                        $event.target.value
                                    "
                                    v-model="field.Table[i][l].Value"
                                  />
                                  <label
                                    :for="i + tableD.Name + p"
                                    class="radioLabel"
                                  >
                                    {{ opt.Key }}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <!-- Select -->
                            <select
                              v-if="tableD.FieldTypeID == 5"
                              class="form-select lp-select"
                              aria-label="Default select example"
                              :valid="tableD.Valid"
                              :required="tableD.Required"
                              :disabled="tableD.Disable"
                              v-model="tableD.Value"
                              @change="tableD.Valid = null"
                            >
                              <option selected>{{ tableD.Placeholder }}</option>
                              <option
                                v-for="opt of tableD.Options"
                                :key="opt.Key"
                                :value="opt.Value"
                                >{{ opt.Value }}</option
                              >
                            </select>
                            <!-- Checkbox -->
                            <base-checkbox
                              class="mb-3"
                              v-model="tableD.Value"
                              :valid="tableD.Valid"
                              v-if="tableD.FieldTypeID == 8"
                              :disabled="tableD.Disable"
                              style="bottom: 10px;left: 42%;"
                            >
                              <i
                                :class="tableD.Icon"
                                aria-hidden="true"
                                v-if="tableD.Icon"
                              ></i>
                              <span v-if="tableD.Required" style="color:#fb6340"
                                >*</span
                              >
                            </base-checkbox>
                          </div>
                        </div>
                        <div class="row" style="margin-top: 1rem">
                          <div class="col" style="text-align: right;">
                            <base-button
                              v-if="
                                field.FieldJSON.table.maxRows >
                                  field.Table.length
                              "
                              class="btn-sm"
                              type="default"
                              icon="fa fa-plus"
                              @click="
                                field.Table.push(
                                  JSON.parse(JSON.stringify(field.Template))
                                )
                              "
                              >Add row</base-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="margin: 20px 0 4rem;display: flex;justify-content: flex-end;"
              >
                <base-button
                  v-if="
                    this.app.progress.sections.fields.pages.length &&
                      page.PageID !=
                        this.app.progress.sections.fields.pages[0].id
                  "
                  type="secondary"
                  style="margin-top: 20px;"
                  @click="BackPage"
                  >Back</base-button
                >
                <base-button
                  type="primary"
                  style="margin-top: 20px;"
                  @click="NextPage"
                  >Next</base-button
                >
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseRadio from "../components/BaseRadio.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  saveApplication,
  getApplication,
  getLoanPage,
  getPageFields,
  runCondition,
  applyToApplication,
  getLoanConditionalPage,
  applyToFields,
} from "../services/application";
import { success, warning, danger } from "../services/message";
export default {
  components: { BaseRadio, flatPicker },
  name: "application",
  data() {
    return {
      id: null,
      progress: 0,
      subTitle: "",
      app: {},
      page: {},
      pagesInfo: {},
      appFields: [],
      fallbackNextPage: null,
      conditionalPages: [],
      loading: false,
      condRegPage: null,
      ready: false,
      coborrower: false,
    };
  },
  async created() {
    if (this.$route.params.pageID && this.$route.params.id) {
      this.id = this.$route.params.id;
      this.loading = true;
      let res = await getApplication(this.id);
      if (res.status === 200) {
        this.app = res.LoanAppJSON;
        this.coborrower = res.coBorrower;
        if (this.$route.query && this.$route.query.type == "c") {
          this.getPageCondition(this.$route.params.pageID);
        } else {
          this.getPage(this.$route.params.pageID);
        }
      } else {
        this.$router.push("/");
        warning(res.message);
      }
    } else if (!this.$route.params.pageID && this.$route.params.id !== "new") {
      this.id = this.$route.params.id;
      let res = await getApplication(this.id);
      this.loading = true;
      if (res.status === 200) {
        this.app = res.LoanAppJSON;
        this.coborrower = res.coBorrower;
        this.getPage();
      } else {
        this.$router.push("/");
        warning(res.message);
      }
    } else {
      this.$router.push("/application/new/agreements");
    }
  },
  methods: {
    setNull(val) {
      val.Valid = null;
      let div = document.getElementById(val.Name);
      div.classList.remove("has-danger");
    },
    async checkRequiredFields() {
      let valid = true;
      let ignore = [];
      for (let i = 0; i < this.appFields.length; i++) {
        const a = this.appFields[i];
        if (a.length) {
          for (let l = 0; l < a.length; l++) {
            const b = a[l];

            if (b.FieldJSON.conditions && b.FieldJSON.conditions.condition) {
              if (await this.checkCondition(b.FieldJSON.conditions, b.Value)) {
                if (
                  b.FieldJSON.conditions.result.remove &&
                  b.FieldJSON.conditions.removeOn
                ) {
                  b.FieldJSON.conditions.result.remove.forEach((el) => {
                    delete this.app.fields[el];
                  });
                }
                if (b.FieldJSON.conditions.result.conditionalPage) {
                  if (
                    !this.conditionalPages.includes(
                      b.FieldJSON.conditions.result.conditionalPage
                    )
                  ) {
                    this.conditionalPages.push(
                      b.FieldJSON.conditions.result.conditionalPage
                    );
                  }
                }
                if (b.FieldJSON.conditions.result.page) {
                  if (this.coborrower) {
                    if (!a.FieldJSON.conditions.result.coborrower) {
                      this.condRegPage = a.FieldJSON.conditions.result.page;
                    }
                  } else {
                    this.condRegPage = a.FieldJSON.conditions.result.page;
                  }
                }
                if (b.FieldJSON.conditions.result.ignore) {
                  ignore.push(...b.FieldJSON.conditions.result.ignore);
                }

                if (b.FieldJSON.conditions.result.values) {
                  for (
                    let v = 0;
                    v < b.FieldJSON.conditions.result.values.length;
                    v++
                  ) {
                    const key = b.FieldJSON.conditions.result.values[v];
                    this.app.fields[key.key] = key.value;
                  }
                }
                if (
                  b.FieldJSON.conditions.result.disable &&
                  b.FieldJSON.conditions.result.disable.length
                ) {
                  b.FieldJSON.conditions.result.disable.forEach((n) => {
                    this.appFields.forEach((c) => {
                      if (c.length) {
                        c.forEach((d) => {
                          if (d.NameID === n.NameID) {
                            d.Disable = true;
                          }
                        });
                      } else {
                        if (c.NameID === n.NameID) {
                          c.Disable = true;
                        }
                      }
                    });
                  });
                } else {
                  this.appFields.forEach((c) => {
                    if (c.length) {
                      c.forEach((d) => {
                        d.Disable = false;
                      });
                    } else {
                      c.Disable = false;
                    }
                  });
                }
              } else {
                if (
                  b.FieldJSON.conditions.result.remove &&
                  !b.FieldJSON.conditions.removeOn
                ) {
                  b.FieldJSON.conditions.result.remove.forEach((el) => {
                    delete this.app.fields[el];
                  });
                }
                if (
                  b.FieldJSON.conditions.result.falseResult &&
                  b.FieldJSON.conditions.result.falseResult.values
                ) {
                  for (
                    let v = 0;
                    v < b.FieldJSON.conditions.result.falseResult.values.length;
                    v++
                  ) {
                    const key =
                      b.FieldJSON.conditions.result.falseResult.values[v];
                    this.app.fields[key.key] = key.value;
                  }
                }
              }
            }
            if (
              b.Required &&
              (!b.Value || b.Value == "$ 0.00") &&
              !ignore.includes(b.NameID)
            ) {
              b.Valid = false;
              valid = false;
            }
          }
        } else {
          if (a.FieldJSON.conditions && a.FieldJSON.conditions.condition) {
            if (await this.checkCondition(a.FieldJSON.conditions, a.Value)) {
              if (a.FieldJSON.conditions.result.conditionalPage) {
                if (
                  !this.conditionalPages.includes(
                    a.FieldJSON.conditions.result.conditionalPage
                  )
                ) {
                  this.conditionalPages.push(
                    a.FieldJSON.conditions.result.conditionalPage
                  );
                }
              }
              if (a.FieldJSON.conditions.result.page) {
                if (this.coborrower) {
                  if (!a.FieldJSON.conditions.result.coborrower) {
                    this.condRegPage = a.FieldJSON.conditions.result.page;
                  }
                } else {
                  this.condRegPage = a.FieldJSON.conditions.result.page;
                }
              }
              if (
                a.FieldJSON.conditions.result.ignore &&
                a.FieldJSON.conditions.result.ignore.length
              ) {
                ignore.push(...a.FieldJSON.conditions.result.ignore);
              }
              if (a.FieldJSON.conditions.result.values) {
                for (
                  let v = 0;
                  v < a.FieldJSON.conditions.result.values.length;
                  v++
                ) {
                  const key = a.FieldJSON.conditions.result.values[v];
                  this.app.fields[key.key] = key.value;
                }
              }
              if (
                a.FieldJSON.conditions.result.disable &&
                a.FieldJSON.conditions.result.disable.length
              ) {
                a.FieldJSON.conditions.result.disable.forEach((n) => {
                  this.appFields.forEach((c) => {
                    if (c.length) {
                      c.forEach((d) => {
                        if (d.NameID === n.NameID) {
                          d.Disable = true;
                        }
                      });
                    } else {
                      if (c.NameID === n.NameID) {
                        c.Disable = true;
                      }
                    }
                  });
                });
              } else {
                this.appFields.forEach((c) => {
                  if (c.length) {
                    c.forEach((d) => {
                      d.Disable = false;
                    });
                  } else {
                    c.Disable = false;
                  }
                });
              }
              if (
                a.FieldJSON.conditions.result.remove &&
                a.FieldJSON.conditions.removeOn
              ) {
                a.FieldJSON.conditions.result.remove.forEach((el) => {
                  delete this.app.fields[el];
                });
              }
            } else {
              if (
                a.FieldJSON.conditions.result.remove &&
                !a.FieldJSON.conditions.removeOn
              ) {
                a.FieldJSON.conditions.result.remove.forEach((el) => {
                  delete this.app.fields[el];
                });
              }
              if (
                a.FieldJSON.conditions.result.falseResult &&
                a.FieldJSON.conditions.result.falseResult
              ) {
                for (
                  let v = 0;
                  v < a.FieldJSON.conditions.result.falseResult.values.length;
                  v++
                ) {
                  const key =
                    a.FieldJSON.conditions.result.falseResult.values[v];
                  this.app.fields[key.key] = key.value;
                }
              }
            }
          }
          if (
            a.Required &&
            (!a.Value || a.Value == "$ 0.00") &&
            !ignore.includes(a.NameID)
          ) {
            a.Valid = false;
            valid = false;
          }
        }
      }
      return valid;
    },
    async NextPage() {
      let valid = await this.checkRequiredFields();

      if (valid) {
        this.app = await applyToApplication(this.appFields, this.app);
        await this.checkRequiredFields();
        this.app.progress.sections.fields.progress =
          this.progress < this.app.progress.sections.fields.progress
            ? this.app.progress.sections.fields.progress
            : this.progress;

        if (this.app.progress.sections.fields.pages) {
          let match = false;
          for (
            let i = 0;
            i < this.app.progress.sections.fields.pages.length;
            i++
          ) {
            const p = this.app.progress.sections.fields.pages[i];
            if (p.id === this.page.PageID) {
              match = true;
            }
          }
          if (!match) {
            this.app.progress.sections.fields.pages.push({
              id: this.page.PageID,
              type: this.page.ConditionalPage ? "c" : "r",
            });
          }
          this.app.progress.sections.fields.pages.sort((a, b) => {
            let av = parseFloat(a.id.replace("-", ""));
            let bv = parseFloat(b.id.replace("-", ""));
            if (av < bv) {
              return -1;
            }
            if (av > bv) {
              return 1;
            }
            return 0;
          });
        } else {
          this.app.progress.sections.fields.pages = [];
          this.app.progress.sections.fields.pages.push({
            id: this.page.PageID,
            type: this.page.ConditionalPage ? "c" : "r",
          });
        }
        if (this.conditionalPages.length) {
          let suc = await this.save();
          if (suc) {
            this.getPageCondition(this.conditionalPages[0]);
          }
        } else {
          // Standard next route
          if (this.pagesInfo.index + 1 === this.pagesInfo.total) {
            this.app.progress.sections.fields.page = this.pagesInfo.nextPage;
            this.app.progress.sections.fields.progress = 100;
            let suc = await this.save();
            if (suc) {
              this.progress = 100;
              setTimeout(() => {
                this.$router.push(
                  `/application/${this.$route.params.id}/documents`
                );
                return;
              }, 500);
            }
          } else {
            this.app.progress.sections.fields.page = this.pagesInfo.nextPage;
            let suc = await this.save();
            if (suc) {
              this.getPage();
            }
          }
        }
      }
    },
    async BackPage() {
      let pages = this.app.progress.sections.fields.pages;
      let b;
      for (let i = 0; i < pages.length; i++) {
        const p = pages[i];
        if (p.id === this.page.PageID) {
          b = pages[i - 1];
        }
      }

      if (b) {
        if (b.type === "c") {
          this.getPageCondition(b.id);
        } else {
          this.getPage(b.id);
        }
      } else {
        if (pages[pages.length - 1].type === "c") {
          this.getPageCondition(pages[pages.length - 1].id);
        } else {
          this.getPage(pages[pages.length - 1].id);
        }
      }
    },
    async getPage(page) {
      this.loading = true;
      this.ready = false;
      let res = await getLoanPage(
        this.id,
        1,
        page || this.condRegPage || this.app.progress.sections.fields.page
      );
      if (res.status === 200) {
        this.page = res.page;
        this.previous = this.condRegPage ? this.previous : res.previousPage;
        this.pagesInfo = res;
        this.subTitle = this.page.Title;
        this.getAppFields(res.current);
        this.progress = Math.round((res.index / res.total) * 100);
      } else {
        warning(res.message);
      }
      this.condRegPage = false;
      this.loading = false;
    },
    async getAppFields(page) {
      this.loading = true;
      let result = await getPageFields(
        page || this.app.progress.sections.fields.page
      );
      if (result.status === 200) {
        this.appFields = result.fields;
        if (this.app.fields) {
          this.appFields = await applyToFields(this.appFields, this.app);
        } else {
          this.app.fields = {};
          this.app.progress.sections.fields.page = this.page.PageID;
        }
      } else {
        warning(result.message);
      }
      this.loading = false;
      this.ready = true;
    },
    async getPageCondition(condPageID) {
      this.loading = true;
      let res = await getLoanConditionalPage(this.id, 1, condPageID);
      this.previous = this.pagesInfo.current;
      if (res.status === 200) {
        this.page = res.page;
        this.subTitle = this.page.Title;
        this.getAppFields(condPageID || this.conditionalPages[0]);
        this.conditionalPages.splice(0, 1);
      } else {
        warning(res.message);
      }
      this.loading = false;
    },

    async checkCondition(condition, value) {
      return await runCondition(condition, value);
    },
    /**
     * Save loan application, this should be call with any change
     */
    async save() {
      if (this.$route.params.id && this.$route.params.id !== "new") {
        let res = await saveApplication(this.$route.params.id, this.app);
        if (res.status === 200) {
          this.app = res.app;
          success("Application Saved");
          return true;
        }
        if (res.status === 400) {
          warning(
            "Can not save an older version of this application. Please try again."
          );
          if (this.$route.params.pageID && this.$route.params.id) {
            this.id = this.$route.params.id;
            this.loading = true;
            let res = await getApplication(this.id);
            if (res.status === 200) {
              this.app = res.LoanAppJSON;
              if (this.$route.query && this.$route.query.type == "c") {
                this.getPageCondition(this.$route.params.pageID);
              } else {
                this.getPage(this.$route.params.pageID);
              }
            } else {
              this.$router.push("/");
              warning(res.message);
            }
          } else if (
            !this.$route.params.pageID &&
            this.$route.params.id !== "new"
          ) {
            this.id = this.$route.params.id;
            let res = await getApplication(this.id);
            this.loading = true;
            if (res.status === 200) {
              this.app = res.LoanAppJSON;
              this.getPage();
            } else {
              this.$router.push("/");
              warning(res.message);
            }
          } else {
            this.$router.push("/application/new/agreements");
          }
          return false;
        } else {
          danger("Error saving application");
          return false;
        }
      }
    },
  },
};
</script>
<style lang="scss">
label {
  font-weight: 600;
}

.templ {
  opacity: 0;
  transition: all 0.4s ease-in-out;
  &.in {
    opacity: 1;
    transition: all 0.4s ease-in-out;
  }
}
.lp-select {
  width: 100%;
  height: 46px;
  border: none;
  background: white;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border-radius: 4px;
  font-size: 14px;
  padding-left: 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none; /* Remove default arrow */
  //  background-image: url();
  &.has-danger {
    color: rgb(251, 99, 64);
    border: 1px solid rgb(251, 99, 64) !important;
  }
}
.tableColumn {
  border-right: 1px solid #8898aa;
  &:last-of-type {
    border-right: none;
  }
}
</style>
